import LocationVisitsTable from "./location-visits-table";


export default LocationVisitsTable;